if (!customElements.get("product-gallery")) {
  customElements.define(
    "product-gallery",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          swiper: this.querySelector(".product-gallery-swiper"),
        };

        const thumbnailSwiper = new Swiper(
          ".product-gallery__thumbnails-swiper",
          {
            // Optional parameters
            slidesPerView: "auto",
            spaceBetween: 16,
            watchSlidesProgress: true,
            // reverseDirection: true,
            slidesOffsetBefore: 64,
            slidesOffsetAfter: 64,
            mousewheel: true,
          }
        );
        const swiper = new Swiper(".product-gallery-swiper", {
          // Optional parameters
          slidesPerView: 1.15,
          spaceBetween: 8,
          slidesOffsetBefore: 16,
          slidesOffsetAfter: 16,
          breakpoints: {
            768: {
              slidesPerView: "auto",
              spaceBetween: 16,
              slidesOffsetBefore: 80,
              slidesOffsetAfter: 80,
            },
            1350: {
              slidesPerView: 1,
              spaceBetween: 0,
              slidesOffsetBefore: 0,
              slidesOffsetAfter: 0,
            },
          },
          thumbs: {
            swiper: thumbnailSwiper,
          },
          on: {
            slideChange: function () {
              window.pauseAllMedia();
            },
          },
          // Navigation arrows
          //   navigation: {
          //     nextEl: ".swiper-button-next",
          //     prevEl: ".swiper-button-prev",
          //   },
        });
      }
    }
  );
}
